"use client";

import { AppSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedAppSection from "../Components/GeneratedAppSection";

const App: FC<AppSectionProps> = (props) => {
  return <GeneratedAppSection {...props} />;
};

export default App;
